import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './Filter.module.scss'

const Filter = ({ filter, applyFilter, selected }) => (
  <div
    styleName={classnames('filter', { selected: selected })}
    onClick={applyFilter}
  >
    {filter}
  </div>
)

Filter.propTypes = {
  filter: PropTypes.string.isRequired,
  applyFilter: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/Filters/Filter/Filter.js